"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOVAL_DOCUMENT_UPLOAD_TYPES_BY_OGC_REASON = exports.DISPUTE_OGC_REASON_BY_DISPUTE_KEY = exports.isCoOwnerDisputeReason = exports.isRemovedCoOwnerReason = exports.CO_OWNER_DISPUTE_OGC_REASONS = void 0;
const coOwnerDisputeKey_1 = require("./coOwnerDisputeKey");
const contingency_1 = require("./contingency");
const documentUpload_1 = require("./documentUpload");
/** @TranslateToPython */
exports.CO_OWNER_DISPUTE_OGC_REASONS = [
    contingency_1.OriginationContingencyReason.deceasedCoOwner,
    contingency_1.OriginationContingencyReason.removedCoOwner,
    contingency_1.OriginationContingencyReason.removedSeparatedSpouse,
    contingency_1.OriginationContingencyReason.removedMarriedSpouse,
    contingency_1.OriginationContingencyReason.coOwnerDispute,
];
const CO_OWNER_DISPUTE_OGC_REASON_SET = new Set(exports.CO_OWNER_DISPUTE_OGC_REASONS);
const isRemovedCoOwnerReason = (reason) => reason in exports.REMOVAL_DOCUMENT_UPLOAD_TYPES_BY_OGC_REASON;
exports.isRemovedCoOwnerReason = isRemovedCoOwnerReason;
const isCoOwnerDisputeReason = (reason) => CO_OWNER_DISPUTE_OGC_REASON_SET.has(reason);
exports.isCoOwnerDisputeReason = isCoOwnerDisputeReason;
/** @TranslateToPython */
exports.DISPUTE_OGC_REASON_BY_DISPUTE_KEY = {
    [coOwnerDisputeKey_1.CoOwnerDisputeKey.notOnTitle]: contingency_1.OriginationContingencyReason.removedCoOwner,
    [coOwnerDisputeKey_1.CoOwnerDisputeKey.onTheListTwice]: contingency_1.OriginationContingencyReason.removedCoOwner,
    [coOwnerDisputeKey_1.CoOwnerDisputeKey.deceased]: contingency_1.OriginationContingencyReason.deceasedCoOwner,
    [coOwnerDisputeKey_1.CoOwnerDisputeKey.widowed]: contingency_1.OriginationContingencyReason.deceasedCoOwner,
    [coOwnerDisputeKey_1.CoOwnerDisputeKey.marriedQuitClaim]: contingency_1.OriginationContingencyReason.removedMarriedSpouse,
    [coOwnerDisputeKey_1.CoOwnerDisputeKey.separated]: contingency_1.OriginationContingencyReason.removedSeparatedSpouse,
    [coOwnerDisputeKey_1.NonRemovalCoOwnerDisputeKey.other]: contingency_1.OriginationContingencyReason.coOwnerDispute,
};
exports.REMOVAL_DOCUMENT_UPLOAD_TYPES_BY_OGC_REASON = {
    [contingency_1.OriginationContingencyReason.removedCoOwner]: [documentUpload_1.DocumentUploadType.LAST_TRANSFER_DOCUMENT, documentUpload_1.DocumentUploadType.QUIT_CLAIM],
    [contingency_1.OriginationContingencyReason.deceasedCoOwner]: [documentUpload_1.DocumentUploadType.DEATH_CERTIFICATE],
    [contingency_1.OriginationContingencyReason.removedMarriedSpouse]: [documentUpload_1.DocumentUploadType.QUIT_CLAIM, documentUpload_1.DocumentUploadType.INTERSPOUSAL_TRANSFER],
    [contingency_1.OriginationContingencyReason.removedSeparatedSpouse]: [documentUpload_1.DocumentUploadType.QUIT_CLAIM, documentUpload_1.DocumentUploadType.INTERSPOUSAL_TRANSFER],
};
